module.exports = __webpack_public_path__ + "static/forecast/weather/nightclear-06cdeb3d43ba0f471c768fd244ec4abb.svg";